<template>
  <ls-table-layout>
    <template #search>
      <PlanPoolSearchForm
        ref="searchForm"
        @search="onSearch"
      />
    </template>
    <template #btn>
      <ls-status-button>
        <download-modal :apiFun="apiSopPurchasePlanPoolReportExport" ref="download" />
        <a-button v-hasPermi="['purchase:planPoolRePort:export']" type="primary" @click="handleExport">导出</a-button>
      </ls-status-button>
    </template>
    <template #tabs>
      <div class="tabs-wrap">
        <ls-button-group
          :current="proposeStatus"
          :button-item="buttonItem"
          type="tabs"
          @select="tabChangeHandler"
        ></ls-button-group>
        <div class="operate-time">最后更新时间：{{operateTime}}</div>
      </div>
    </template>
    <template #table>
      <ls-api-table
        ref="planPoolTable"
        class="plan-pool-Table"
        :columns="columns"
        :tableProps="tableProps"
        :pagination="pagination"
        :scroll="{fixScreen:true,x:800,extraHeight: 100}"
        @changeColumns="changeColumns"
        @successCallBack="successCallBack"
        :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.PLAN_POOL_REPORT_LIST, // 表格方案配置唯一值
              }"
      >
        <template slot="footer">
          <StickyFixedSummary
            ref="summaryRef"
            :footerTableColumns="footerColumns"
            :columns="columns"
            :dateFiledList="dateFiledList" />
        </template>
      </ls-api-table>
    </template>
  </ls-table-layout>
</template>

<script>
import PlanPoolSearchForm from '@/views/report/plan-pool-report/components/plan-pool-search-form'
import { generateLsTableResData } from '@/utils/util'
import { fixedTable } from "lsmy-libs";
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import { apiSopPurchasePlanPoolReportList, apiSopPurchasePlanPoolReportExport, apiGetQueryTotal } from '@/api/report/ordinary-report'
import cloneDeep from 'lodash.clonedeep'
import StickyFixedSummary from '@/components/StickyFixedSummary'
const dateFiledList = [
  { title: '1月', dataIndex: 'month01' },
  { title: '2月', dataIndex: 'month02' },
  { title: '3月', dataIndex: 'month03' },
  { title: '4月', dataIndex: 'month04' },
  { title: '5月', dataIndex: 'month05' },
  { title: '6月', dataIndex: 'month06' },
  { title: '7月', dataIndex: 'month07' },
  { title: '8月', dataIndex: 'month08' },
  { title: '9月', dataIndex: 'month09' },
  { title: '10月', dataIndex: 'month10' },
  { title: '11月', dataIndex: 'month11' },
  { title: '12月', dataIndex: 'month12' }
]

export default {
  name: 'PlanPoolReport',
  components: {
    PlanPoolSearchForm,
    StickyFixedSummary,
    DownloadModal
  },
  mixins: [fixedTable],
  data() {
    return {
      apiSopPurchasePlanPoolReportExport,
      operateTime: '', // 最后更新时间
      proposeStatus: 1,
      buttonItem: [
        { id: 1, name: '待签署计划单' },
        { id: 2, name: '已签署计划单' },
        { id: 3, name: '已确定采购订单' },
        { id: 5, name: '未确定采购订单' },
        { id: 4, name: '待检采购订单' }
      ],
      dateFiledList: [],
      columns: [
        { dataIndex: 'index', title: '序号', width: 42, customRender: (text, record, index) => record.index === '合计' ? '合计' : index + 1 },
        { title: '供应商', dataIndex: 'supplierName', ellipsis: true, width: 100, customRender: (text, record) => text ? (record.supplierCode + '-' + text) : text },
        { title: '项目部', dataIndex: 'projectDept', ellipsis: true, width: 85 },
        { title: '物料编码', dataIndex: 'itemCode', ellipsis: true, width: 90 },
        { title: '物料名称', dataIndex: 'itemName', ellipsis: true, width: 85 },
        { title: '规格描述', dataIndex: 'specification', width: 110, ellipsis: true },
        { title: '计划专员', dataIndex: 'planUser', width: 85, ellipsis: true },
        { title: '系列主型号', dataIndex: 'seriesModel', width: 90, ellipsis: true },
        ...dateFiledList
      ],
      footerColumns: [],
      tableProps: {
        requestApi: generateLsTableResData(apiSopPurchasePlanPoolReportList, false),
        pageCurrent: true
      },
      pagination: {
        pageSizeOptions: ["10", "20", "50", "100"]
      }
    }
  },
  computed: {},
  methods: {
    // 表单搜索
    onSearch (value = {}) {
      const params = cloneDeep({ ...value, status: this.proposeStatus })
      if(value.year && value.year.length === 4) {
        params.year = value.year + '-01-01'
      }
      delete params.searchFormLabel
      this.$refs.planPoolTable.searchParams = params;
      if (this.$refs?.summaryRef) {
        this.setSummaryColumns()
      }
      this.$refs.planPoolTable.getData();
    },
    tabChangeHandler(val) {
      this.proposeStatus = val?.[0]?.id
      this.onSuccess()
    },
    onSuccess() {
      const value = this.$refs.planPoolTable.searchParams
      this.onSearch(value)
    },
    changeColumns() {
      this.setSummaryColumns()
    },
    setSummaryColumns() {
      const listColumns = this.$refs.planPoolTable.columns
      if(listColumns?.length > 0) {
        const hideColumnsIndex = listColumns.filter(item => item.invisiable).map(item => item.dataIndex)
        if(hideColumnsIndex?.length > 0) {
          this.footerColumns = this.columns.filter(item => !hideColumnsIndex.includes(item.dataIndex))
          this.dateFiledList = dateFiledList.filter(item => !hideColumnsIndex.includes(item.dataIndex))
        }else {
          this.footerColumns = this.columns
          this.dateFiledList = dateFiledList
        }
      }
      const params = this.$refs.planPoolTable.searchParams
      const self = this
      apiGetQueryTotal(params).then(res => {
        if (res.code === 200) {
          const resData = res?.data || {}
          self.$refs.summaryRef.sumInfoList = [{ index: '合计', ...resData }]
          // self.$nextTick(() => {
          //   if (self.$refs?.planPoolTable) self.$refs.summaryRef.initSet(self.$refs.planPoolTable)
          // })
        }
      })
    },
    successCallBack(data) {
      // 只获取初始化一次，有值则不再获取
      if(!this.operateTime && this.$refs?.planPoolTable?.myPagination?.current === 1 && data?.length > 0) {
        // 获取第一页第一行的创建时间为最后更新时间
        const getFirst = data[0]
        if(getFirst?.createTime) { this.operateTime = this.$moment(getFirst.createTime).format('YYYY-MM-DD HH:mm') }
      }
    },
    // 导出
    handleExport() {
      const params = this.$refs.planPoolTable.searchParams
      this.$refs.download.openModal(params)
    }
  },
  mounted () {
    this.operateTime = ''; // 只在初始化清空一次
  }
}
</script>

<style lang="less" scoped>
@import '../../../components/StickyFixedSummary/styles/footerTable.less';
.tabs-wrap{
  position: relative;
  .operate-time{
    position: absolute;
    top: 15px;
    right: 20px;
  }
}
</style>
